import { useEffect } from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, TrackingLocation, click } from '@tracking';

interface InlineLinkProps {
  trackingLocation: TrackingLocation;
  targetSelector: string;
}

const useInlineLinkTracking = ({ trackingLocation, targetSelector }: InlineLinkProps) => {
  const { trackEvent } = useEventTracking({
    location: trackingLocation,
  });

  useEffect(() => {
    const handleAnchorClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // Check if the clicked element is an anchor tag
      if (target.nodeName === 'A') {
        trackEvent(
          click({
            clickLink: (target as HTMLAnchorElement).href,
            clickTarget: ClickTarget.AnchorLink,
            clickText: target.innerText,
          })
        );
      }
    };

    const content = document.querySelector(targetSelector);
    content?.addEventListener('click', handleAnchorClick, true);

    return () => {
      content?.removeEventListener('click', handleAnchorClick, true);
    };
  }, [trackEvent, targetSelector]);
};

export default useInlineLinkTracking;
